<template>
  <div>
    <top-bar title="Confirme seus dados"/>
    <div class="container" v-if="zap" style="max-width: 400px">
      <form @submit.prevent="validate">
        <div class="form-group mb-2">
          <label class="mb-0 font-weight-bold small">Telefone *</label>
          <div class="form-control" style="background-color: #E9ECEF;">{{usuario.telefone | maskPhone}}</div>
        </div>
        <div class="form-group">
          <label class="mb-0 font-weight-bold small">Nome completo * <a href="javascript:" class="text-info" @click="editar = true" v-if="!bloquear_nome">(Alterar)</a></label>
          <input type="text" id="nomeZap" class="form-control" placeholder="Seu nome completo" v-model="usuario.nome_user" maxlength="45" required :disabled="!editar && token" style="text-transform: capitalize">
        </div>
        <hr>
        <button class="btn btn-primary btn-block py-2" :disabled="load">
          <span v-show="load"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
          <span v-show="!load">Confirmar</span>
        </button>
        <button type="button" class="btn btn-block text-primary py-2" @click="deslogar()" :disabled="load">
          Não sou eu
        </button>
      </form>
      <div class="my-4 text-muted">
        <div class="small">Concordo com os <a href="https://lecard.delivery/termos-de-uso/" target="_blank" class="text-primary font-weight-bold">Termos e Condições de uso</a>.</div>
        <div class="small">Estou enviando informações verdadeiras podendo responder civilmente perante a lei.</div>
      </div>
    </div>
    <div style="padding: 8px 0 32px" v-show="!zap">
      <div class="container">
        <div>
          <login-facebook str="Entrar com Facebook"/>
          <form @submit.prevent="validate">
            <div class="form-group mb-2">
              <label class="mb-0 font-weight-bold small">Email *</label>
              <input type="email" class="form-control" placeholder="Seu endereço de email" v-model="usuario.email" maxlength="100" autocomplete="username" required>
            </div>
            <div class="form-group mb-2">
              <label class="mb-0 font-weight-bold small">Senha *</label>
              <input type="password" class="form-control" placeholder="Senha" v-model="usuario.senha" maxlength="100" autocomplete="password" required>
            </div>
            <button class="btn btn-primary btn-block mt-3 mb-2">
              <span v-show="load"><i class="fa fa-spinner fa-pulse"></i> Aguarde</span>
              <span v-show="!load">Logar</span>
            </button>
          </form>
          <div class="mt-4 text-center">Ainda não é cadastrado? <router-link to="cadastro" class="text-info">Cadastrar</router-link></div>
          <div class="mt-2 text-center">Esqueceu sua senha? <router-link to="esqueci-senha" class="text-info">Recuperar</router-link></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {TheMask} from 'vue-the-mask';
  import LoginFacebook from '../../../components/auth/LoginFacebook';
  import TopBar from "../../../components/TopBar";
  import CardInfo from "../../../components/CardInfo";

  export default {
    name: 'Login',
    components: {CardInfo, TopBar, LoginFacebook, TheMask },
    data() {
      return {
        token: localStorage.getItem('token'),
        url: '',
        load: false,
        nome_old: null,
        editar: false,
        bloquear_nome: false,
        usuario:  {
          email: '',
          senha: '',
          telefone: '',
          nome_user: '',
          recaptcha: ''
        }
      }
    },

    methods: {
      logarUsuario() {
        if (this.token && this.nome_old === this.usuario.nome_user) {
          sessionStorage.setItem('zap-confirmado', '1');
          this.$router.push(this.url + '/finalizar');
          return;
        }

        this.load = true;

        this.$http.post(this.empresa.token + '/login', this.usuario)
          .then(res => {
            if (res && res.data.success) {
              this.$store.state.zap.nome_user = this.usuario.nome_user;
              sessionStorage.setItem('zap-confirmado', '1');
              sessionStorage.setItem('session-zap', JSON.stringify(this.zap));
              this.$emit('registrarLogin', res);

            } else {
              console.log(res);
            }

            this.load = false;

          }, res => {
            console.log(res);
            let msg = res.data && res.data.msg ? res.data.msg : 'Erro temporário';
            this.$swal(msg);
          });
      },

      validate() {
        if (this.load) {
          return;
        }

        if (this.zap && (!this.usuario.nome_user || this.usuario.nome_user.trim().length < 3)) {
          this.$swal("Por favor informe um nome válido!").then(() => {
            this.$helpers.focusrElement("nomeZap");
          });

          return;
        }

        this.logarUsuario();
      },

      deslogar() {
        this.$swal({
          text: 'Você será redirecionado para trocar de conta. Deseja continuar?',
          buttons: ["Cancelar", "Sim"],
          dangerMode: true,
        }).then((r) => {
          if (r) {
            localStorage.removeItem('token');
            localStorage.removeItem(this.empresa.dominio_delivery);
            this.$store.state.zap = null;
            this.$store.state.dataUser = {};
            this.$router.push(this.url + '/perfil/cadastro');
          }
        });
      }
    },

    mounted() {
      this.url = this.origin === '5' ? '/' + this.empresa.dominio_delivery : '';

      if (this.zap && this.token && sessionStorage.getItem('zap-confirmado')) {
        this.$router.push(this.url + '/finalizar');

      } else if (this.zap) {
        this.bloquear_nome = !this.token || !!this.empresa.json_config.bloquear_nome;
        this.usuario.telefone = this.zap.telefone;
        this.usuario.nome_user = this.zap.nome_user;
        this.nome_old = this.zap.nome_user;
        this.usuario.hash_zap = this.zap.hash_user;
        this.$helpers.focusrElement("nomeZap");

      } else {
        this.$router.push(this.url + '/perfil');
      }
    },

    created() {
      document.body.classList.remove("modal-open");
    },

    computed: {
      empresa() {
        return this.$store.state.empresa;
      },

      zap() {
        return this.$store.state.zap;
      }
    }
  }
</script>

<style scoped>
</style>
